(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/information-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/information-abtest.js');
'use strict';

const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  URL
} = svs.selfExclusion.Constants;
const {
  accordionabtest
} = svs.selfExclusion;
const {
  useState
} = React;
const InformationAbTest = () => {
  const [expanded, setExpanded] = useState(false);
  const handleChange = item => isExpanded => {
    setExpanded(isExpanded ? item : '');
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2",
    id: "readMore"
  }, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2",
    id: "qanda"
  }, "Fr\xE5gor och svar"), React.createElement(Accordion, {
    customer: "sport"
  }, accordionabtest.map(item => React.createElement(AccordionItem, {
    isExpanded: expanded === accordionabtest[item.id],
    key: item.id,
    onChange: handleChange(accordionabtest[item.id])
  }, React.createElement(AccordionSummary, null, React.createElement("h4", null, item.title)), React.createElement(AccordionDetails, null, React.createElement("p", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, item.content))))), React.createElement("div", {
    className: "more-questions-bottom"
  }, React.createElement("p", {
    className: "padding-top-2"
  }, React.createElement("strong", null, "Har du fler fr\xE5gor? "), React.createElement("a", {
    className: "fc-black",
    href: URL.CUSTOMER_SERVICE_HOME,
    rel: "noreferrer",
    target: "_blank"
  }, "Kontakta kundservice"))));
};
svs.selfExclusion.components.InformationAbTest = InformationAbTest;

 })(window);